import {config} from "./index.js";

export default function asMobile() {
    return config.win.width < config.break.md;
}